<button class="{{size}}" [attr.type]="type" [attr.tabindex]="(disabled ? -1 : 0)" style="-webkit-background:none;background:none;border:none;">
  <svg width="100%" height="100%">
    <defs>
      <linearGradient id="linear-{{id}}" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" [attr.stop-color]="colors.start" />
        <stop offset="100%" [attr.stop-color]="colors.stop" />
      </linearGradient>
      <linearGradient id="linear-vertical-{{id}}" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" [attr.stop-color]="colors.start" />
        <stop offset="100%" [attr.stop-color]="colors.stop" />
      </linearGradient>
    </defs>
    <rect *ngIf="size == 'default'" x="1" y="2" width="98%" rx="15" ry="15" height="47" [attr.fill]="gradientUrls.fill"
      [attr.stroke]="gradientUrls.stroke"></rect>
    <rect *ngIf="size == 'small'" x="1" y="2" width="98%" rx="12" ry="12" height="37" [attr.fill]="gradientUrls.fill"
      [attr.stroke]="gradientUrls.stroke"></rect>
    <rect *ngIf="size == 'extra-small'" x="1" y="2" width="98%" rx="10" ry="10" height="27"
      [attr.fill]="gradientUrls.fill" [attr.stroke]="gradientUrls.stroke"></rect>
  </svg>
  <span>
    <ng-content></ng-content>
  </span>
</button>
